module.exports = __webpack_public_path__ + "static/media/person-dolly-empty.cd23d0bf.svg";